import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { notification } from 'antd';
import moment from 'moment';
import { API_ENDPOINT } from '../../../utility';
import axiosService from '../../../utility/axiosService/axiosService';
const openNotification = (placement) => {
    notification.info({
        message: `Notification ${placement}`,
        description: 'Cập nhật dữ liệu thất bại',
        placement
    });
    notification.open({
        open: true
    });
};

const openNotificationWithIcon = (type) => {
    notification[type]({
        message: 'Notification Title',
        description:
            'This is the content of the notification. This is the content of the notification. This is the content of the notification.'
    });
};

export const updateContact = createAsyncThunk('users/updateContact', async (id) => {
    console.log(id);
    return await axiosService.post(`${API_ENDPOINT}/admin/contact-consultant/${id}`).then(
        (res) => {
            console.log(res.data.mess);
            openNotificationWithIcon('success');
            if (res.data.mess === 'res.data.mess') {
                getContact();
            }
            // openNotifiUpdate();
            return res.data.mess;
        },
        (error) => {
            openNotification();
        }
    );
});

export const closeSnackbar = createAsyncThunk('users/closeSnackbar', async (data) => {
    console.log(data);
});
// export const pagention =  createAsyncThunk(
//     'users/closeSnackbar',
//     async (data)=>{
//         console.log(data)

//     }
// )

export const getContact = createAsyncThunk('users/getContact', async (data) => {
    console.log(data);
    var findkey = data.keyword;
    var is_consulted = data.is_consulted
    var producline = data.producline
 
    var limit = data.search === 'action' ? 100 : data.limit;
    var page = data.search === 'action' ? 1 : data.page;
    var start_date = data.fromDate;
    var end_date = data.toDate
    var keyword = data.search
    return await axiosService
        .get(`${API_ENDPOINT}/admin/contact-consultant?${keyword}${start_date}${end_date}${is_consulted}${producline}&limit=${limit}&page=${page}`)
        .then((res) => {
            console.log(res.data.data.result);
            var contact = res.data;
            var filter = res.data.data.result.filter(
                (item) =>
                    (item.full_name.toLowerCase() !== null &&
                        item.full_name.toLowerCase().includes(findkey.toLowerCase())) ||
                    (item.email.toLowerCase() !== null &&
                        item.email.toLowerCase().includes(findkey.toLowerCase())) ||
                    (item.phone.toLowerCase() !== null &&
                        item.phone.toLowerCase().includes(findkey.toLowerCase())) 
                        //not working when add line, but remove it work :
                        // moment(item.createdAt).utc().format('YYYY-MM-DD') >= start &&
                        //  moment(item.createdAt).utc().format('YYYY-MM-DD') <= end
                       
                 
            );

            
            var fil =
                data.keyword === null ||
                data.keyword === '' ||
                (data.keyword === 'all' && data.defaultVal === 'all')
                    ? contact
                    : filter ;
                  
              


            return fil
        });
});






export const findByDate = createAsyncThunk('users/findByDate', async (dataFilter) => {
    console.log(dataFilter);
    var start = dataFilter.dateStrings[0];
    var end = dataFilter.dateStrings[1];
    var is_consulted = dataFilter.filterParams.is_consulted
    var producline = dataFilter.filterParams.producline
    var active = String(dataFilter) == 'true';
    var limit = dataFilter.filterParams.limit;
    var page = dataFilter.filterParams.page

    console.log(active);
    var x = Number(dataFilter);
    console.log(x);

    return await axiosService
        .get(`${API_ENDPOINT}/admin/contact-consultant?${is_consulted}&${producline}&limit=${limit}&page=${page}`)
        .then((res) => {
            var fdate = res.data.data.result.filter(
                (item) =>
                    moment(item.createdAt).utc().format('YYYY-MM-DD') >= start &&
                    moment(item.createdAt).utc().format('YYYY-MM-DD') <= end
            );
            console.log(fdate);
            return fdate;
        });
});
const campaignContactSlice = createSlice({
    name: 'campaignContact',
    initialState: {
        loading: false,
        modal: false,
        toast: false,
        data: [],
        total_page: 0,
        dataCampaignContact: [],
        finddataContact: [],
        upadateContact: {},
        dataDetailsContact: null,
        error: null,
        keyword: '',
        page: 1,
        producline:[],    
        dataFilter: {
            keyword: '',
            page: 1,
            date: []
        },
        dataProduct: {
            keywordproduct: '',
            page: 1
        }
    },
    reducers: {
        getModal: (state, { payload }) => {
            state.modal = true;
            state.dataDetails = payload;
        },
        getFind: (state, { payload }) => {
            state.modal = true;
            state.dataProduct = payload;
        },
        removeModal: (state) => {
            state.dataDetails = null;
            state.modal = false;
        },
        searchTextFieldSlice: (state, { payload }) => {
            state.keyword = payload.data;
        },
        paginationHandleSlice: (state, { payload }) => {
            state.page = payload.data;
        },
        filterData: (state, { payload }) => {
            state.dataFilter.keyword = payload.page
                ? payload.keyword || state.dataFilter.keyword
                : payload.keyword;
            state.dataFilter.page = payload.page || state.dataFilter.page;
        }
    },
    extraReducers: {
        [getContact.pending]: (state) => {
            state.loading = true;
        },
        [getContact.fulfilled]: (state, {payload }) => {
            console.log(payload)
            state.dataCampaignContact = payload.data
            state.total_page = payload.total_page;
            state.loading = false;
        },
        [updateContact.pending]: (state) => {
            state.loading = true;
        },
        [updateContact.fulfilled]: (state, { payload }) => {
            state.upadateContact = payload.data;
            state.toast = true;
        },
        [findByDate.fulfilled]: (state, { payload }) => {
            state.dataCampaignContact = payload;
            state.total_page = 1;
            state.loading = false;
        },
       
        
        [closeSnackbar.fulfilled]: (state, { payload }) => {
            state.toast = false;
        }
    }
});

export const {
    getModal,
    getFind,
    removeModal,
    filterData,
    searchTextFieldSlice,
    paginationHandleSlice
} = campaignContactSlice.actions;

export default campaignContactSlice.reducer;